export class RestoreAzureVMInstanceConfig {
    'vmSize';
    'networkInterface';
    'tags';
    'diskSettings';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vmSize",
            "baseName": "vmSize",
            "type": "string",
            "format": ""
        },
        {
            "name": "networkInterface",
            "baseName": "networkInterface",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "diskSettings",
            "baseName": "diskSettings",
            "type": "Array<RestoreAzureDiskRequest>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureVMInstanceConfig.attributeTypeMap;
    }
    constructor() {
    }
}
